"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
exports.DAY_IN_MS = 24 * 60 * 60 * 1000;
exports.WEEK_IN_MS = 7 * exports.DAY_IN_MS;
exports.MONTH_IN_MS = 30 * exports.DAY_IN_MS;
exports.YEAR_IN_MS = 365 * exports.DAY_IN_MS;
function getStartDateToday() {
    var newStartDate = new Date();
    newStartDate.setHours(0, 0, 0, 0);
    return newStartDate;
}
exports.getStartDateToday = getStartDateToday;
function getEndDateToday() {
    var newEndDate = new Date();
    newEndDate.setHours(23, 59, 59, 999);
    return newEndDate;
}
exports.getEndDateToday = getEndDateToday;
function getMonthYearInLocale(date) {
    return moment(date).format('L')
        .replace(new RegExp('[^\.]?' + moment(date).format('YYYY') + '.?'), '');
}
exports.getMonthYearInLocale = getMonthYearInLocale;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS11dGlsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZGF0ZS11dGlsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsK0JBQWtDO0FBRXJCLFFBQUEsU0FBUyxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxHQUFHLElBQUksQ0FBQztBQUNoQyxRQUFBLFVBQVUsR0FBRyxDQUFDLEdBQUcsaUJBQVMsQ0FBQztBQUMzQixRQUFBLFdBQVcsR0FBRyxFQUFFLEdBQUcsaUJBQVMsQ0FBQztBQUM3QixRQUFBLFVBQVUsR0FBRyxHQUFHLEdBQUcsaUJBQVMsQ0FBQztBQUUxQztJQUNJLElBQUksWUFBWSxHQUFHLElBQUksSUFBSSxFQUFFLENBQUM7SUFDOUIsWUFBWSxDQUFDLFFBQVEsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQztJQUNsQyxPQUFPLFlBQVksQ0FBQztBQUN4QixDQUFDO0FBSkQsOENBSUM7QUFFRDtJQUNJLElBQUksVUFBVSxHQUFHLElBQUksSUFBSSxFQUFFLENBQUM7SUFDNUIsVUFBVSxDQUFDLFFBQVEsQ0FBQyxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxHQUFHLENBQUMsQ0FBQztJQUNyQyxPQUFPLFVBQVUsQ0FBQztBQUN0QixDQUFDO0FBSkQsMENBSUM7QUFFRCw4QkFBcUMsSUFBWTtJQUM3QyxPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDO1NBQzFCLE9BQU8sQ0FBQyxJQUFJLE1BQU0sQ0FBQyxRQUFRLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsR0FBRyxJQUFJLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztBQUNoRixDQUFDO0FBSEQsb0RBR0MifQ==


//////////////////
// WEBPACK FOOTER
// ./src/app/common/date/date-util.ts
// module id = 267
// module chunks = 0